import './ContactForm.css'
import { contactWithMe } from '../../../../Misc/firebase'
import { useState } from 'react';
export default function ContactForm() {
	const [sent, setSent] = useState(false)
	return (
		<div className='ContactForm w-full xl:w-3/4 h-fit bg-slate-800 flex flex-col p-6 md:p-10 space-y-6 lg:rounded-xl mx-auto'>
			<p className='mb-[-2vh] text-3xl text-green-400 font-semibold'>Get in touch</p>

			<input type="text" placeholder='Name' id="name" />
			<input type="email" placeholder='Email' id="email" />

			<textarea name="" placeholder='Message' id="txta1" cols={30} rows={10} ></textarea>
			<button className='bg-slate-800 border-4 border-green-400 send-btn text-white w-fit mx-auto px-10 py-2 rounded-lg hover:bg-green-400 duration-100 text-lg font-semibold'
				onClick={function () {
					const namefield = document.getElementById("name") as HTMLInputElement;
					const emailfield = document.getElementById("email") as HTMLInputElement;
					const msgfield = document.getElementById("txta1") as HTMLTextAreaElement;

					const name = namefield.value;
					const email = emailfield.value;
					const msg = msgfield.value;
					console.log(msg)

					contactWithMe({
						name: name,
						email: email,
						msg: msg
					}).then((res) => {
						setSent(()=>true)
					})
						.catch(err => { console.error(err) })
				}}
			>Send</button>

				{
					sent ? <div className="text-green-400 text-center font-semibold">
						Thank you. I will contact you as soon as possible
					</div> : ""
				}
		</div>
	)
}